import React, { useState } from 'react';
import { useLms } from '../../context/LmsContext';
import { Card, FormRow, PageHeader } from '../../components/ui';

function formatDateTime(value) {
  if (!value) return 'Not synced yet';
  return new Date(value).toLocaleString();
}

export default function AdminSettings() {
  const { data, currentUser, updateSettings, storageStatus, checkSupabaseConnection } = useLms();
  const [form, setForm] = useState(data.settings);
  const [message, setMessage] = useState('');
  const [testing, setTesting] = useState(false);

  const submit = (event) => {
    event.preventDefault();
    updateSettings({
      ...form,
      defaultPassingScore: Number(form.defaultPassingScore),
      defaultMaxAttempts: Number(form.defaultMaxAttempts),
      dueSoonDays: Number(form.dueSoonDays),
      sessionHours: Number(form.sessionHours)
    }, currentUser.id);
    setMessage('Settings saved to Supabase.');
  };

  const testConnection = async () => {
    setTesting(true);
    const result = await checkSupabaseConnection();
    setMessage(result.message);
    setTesting(false);
  };

  return (
    <>
      <PageHeader title="Admin settings" eyebrow="Admin" description="Configure global LMS defaults for grading, approval, certificates, notifications, security, and Supabase database storage." />
      <div className="grid two uneven">
        <Card>
          <h2>Global configuration</h2>
          <form className="form-stack" onSubmit={submit}>
            <label className="check-row"><input type="checkbox" checked={Boolean(form.approvalRequired)} onChange={(e) => setForm({ ...form, approvalRequired: e.target.checked })} /> Admin approval required before publish</label>
            <div className="form-grid">
              <FormRow label="Default passing score"><input type="number" min="0" max="100" value={form.defaultPassingScore} onChange={(e) => setForm({ ...form, defaultPassingScore: e.target.value })} /></FormRow>
              <FormRow label="Default max attempts"><input type="number" min="1" value={form.defaultMaxAttempts} onChange={(e) => setForm({ ...form, defaultMaxAttempts: e.target.value })} /></FormRow>
            </div>
            <div className="form-grid">
              <FormRow label="Due soon reminder days"><input type="number" min="1" value={form.dueSoonDays} onChange={(e) => setForm({ ...form, dueSoonDays: e.target.value })} /></FormRow>
              <FormRow label="Session length hours"><input type="number" min="1" value={form.sessionHours} onChange={(e) => setForm({ ...form, sessionHours: e.target.value })} /></FormRow>
            </div>
            <FormRow label="Allowed email domain"><input value={form.allowedEmailDomain} onChange={(e) => setForm({ ...form, allowedEmailDomain: e.target.value })} /></FormRow>
            <FormRow label="Certificate issuer"><input value={form.certificateIssuer} onChange={(e) => setForm({ ...form, certificateIssuer: e.target.value })} /></FormRow>
            <button className="button button-primary" type="submit">Save settings</button>
            {message && <p className="muted small">{message}</p>}
          </form>
        </Card>

        <div className="stack">
          <Card>
            <h2>Supabase database</h2>
            <div className="status-list">
              <div><span>Mode</span><strong>Supabase database</strong></div>
              <div><span>Status</span><strong>{storageStatus.message}</strong></div>
              <div><span>Last sync</span><strong>{formatDateTime(storageStatus.lastSyncedAt)}</strong></div>
              {storageStatus.error && <div><span>Error</span><strong className="danger-text">{storageStatus.error}</strong></div>}
            </div>
            <button className="button" type="button" onClick={testConnection} disabled={testing}>{testing ? 'Testing...' : 'Test Supabase connection'}</button>
            <p className="muted small">This production build requires REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY. Data is not saved to localStorage.</p>
          </Card>
          <Card>
            <h2>Configured categories</h2>
            <div className="tag-cloud">{data.categories.map((category) => <span key={category}>{category}</span>)}</div>
            <p className="muted">Users, courses, lessons, quizzes, assignments, progress, grades, certificates, and settings are stored in Supabase production tables. External files are not uploaded; resource links remain unchanged.</p>
          </Card>
        </div>
      </div>
    </>
  );
}
